import { Component, computed, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { toSignal } from '@angular/core/rxjs-interop';
import { UpdateNote, UpdateNoteType } from '../../types/update-note';
import { resolveUpdateNoteContent } from '../../utils/resolve-update-note-content';

@Component({
  selector: 'app-update-note-card',
  imports: [DatePipe, TranslocoPipe],
  templateUrl: './update-note-card.component.html',
})
export class UpdateNoteCardComponent {
  private translocoService = inject(TranslocoService);

  note = input.required<UpdateNote>();

  /**
   * A signal rather than a pipe: transloco is configured with reRenderOnLangChange, so the content
   * must re-resolve when the user switches language without refetching anything.
   */
  private activeLang = toSignal(this.translocoService.langChanges$, {
    initialValue: this.translocoService.getActiveLang(),
  });

  content = computed(() =>
    resolveUpdateNoteContent(this.note(), this.activeLang()),
  );

  badgeClass = computed(() =>
    this.note().type === UpdateNoteType.EMISSION_FACTORS
      ? 'bg-warning-100 text-warning-700'
      : 'bg-primary-100 text-primary-700',
  );
}
